// extracted by mini-css-extract-plugin
export default {"navigation_container":"NavigationTitle_navigation_container__dO+TO","back_icon":"NavigationTitle_back_icon__gyxSC","text_container":"NavigationTitle_text_container__Gtluu"};